// Inside db.ts
import type { Table } from 'dexie'
import Dexie from 'dexie'
import type { Team, GameTransaction, PlateAppearance, GameMetadata } from 'src/stores/base-types'

import type { UserProfile } from 'src/stores/auth-store-types'

export class PitchTrackerDB extends Dexie {
  teams!: Table<Team, number>
  users!: Table<UserProfile, string>
  games!: Table<GameMetadata, string>
  transactions!: Table<GameTransaction, string>
  plateAppearances!: Table<PlateAppearance, string>

  constructor() {
    super('PitchTrackerDB')

    // Define the schema. The first string is the Primary Key.
    // Subsequent strings are indexes we want to query by.
    this.version(1).stores({
      users: 'id, username',
      games: 'gameId',
      transactions: 'id, gameId, plateAppearanceId',
      plateAppearances: 'id, gameId',
      // '++id' means: Auto-increment the primary key.
      // 'name' means: Index the name field so I can quickly search/sort by it.
      // Notice we do NOT index the 'players' array. You only index things you search by.
      teams: '++id, name',
    })
  }
}

// THIS is what you are importing later
export const db = new PitchTrackerDB()
